module.exports = __webpack_public_path__ + "static/img/case4.4f4a440f.jpg";